import React from 'react';
import PropTypes from 'prop-types';
import { Button, Content } from '@leverege/ui-elements';
import ReactResizeDetector from 'react-resize-detector';
import SwipeHandlerModule from 'react-easy-swipe';
import classnames from 'classnames';
import I18N from '@leverege/i18n';
import S from './Swipe.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SwipeHandler = SwipeHandlerModule.default;
const {
  t
} = I18N.ns('molten.views.Swipe');
class Swipe extends React.Component {
  /*
    the eslint disabling is because this component naively maps state into props in the constructor.
    Regardless of if thats the best thing to be doing, please don't remove these default props.
   */
  static propTypes = {
    swipeLocation: PropTypes.string,
    middleLocation: PropTypes.string,
    topLocation: PropTypes.string,
    bottomLocation: PropTypes.string,
    background: PropTypes.object,
    overlay: PropTypes.object,
    swipeSensitivity: PropTypes.number,
    // eslint-disable-line react/no-unused-prop-types
    swiping: PropTypes.bool,
    // eslint-disable-line react/no-unused-prop-types
    backgroundHeight: PropTypes.string,
    // eslint-disable-line react/no-unused-prop-types
    overlayHeight: PropTypes.string,
    // eslint-disable-line react/no-unused-prop-types
    // one of swipe or split
    mode: PropTypes.string // eslint-disable-line react/no-unused-prop-types
  };
  static defaultProps = {
    swipeLocation: 'middle',
    middleLocation: '50%',
    topLocation: '100%',
    bottomLocation: '40px',
    background: null,
    overlay: null,
    swipeSensitivity: 10,
    swiping: false,
    overlayHeight: null,
    backgroundHeight: null,
    mode: 'swipe'
  };
  constructor(props) {
    super(props);
    this.overlayRef = /*#__PURE__*/React.createRef();
    this.backgroundRef = /*#__PURE__*/React.createRef();
    this.dividerRef = /*#__PURE__*/React.createRef();
    this.dividerMarkRef = /*#__PURE__*/React.createRef();
    this.state = {
      ...props
    };
  }
  static getDerivedStateFromProps(props) {
    const {
      topLocation,
      middleLocation,
      bottomLocation
    } = props;
    return {
      topLocation,
      middleLocation,
      bottomLocation
    };
  }
  componentDidUpdate(prevProps) {
    const {
      topLocation,
      middleLocation,
      bottomLocation,
      swipeLocation
    } = this.props;
    if (topLocation !== prevProps.topLocation && swipeLocation === 'top' || middleLocation !== prevProps.middleLocation && swipeLocation === 'middle' || bottomLocation !== prevProps.bottomLocation && swipeLocation === 'bottom') {
      // I am inevitable
      this.snap();
    }
  }
  onBackgroundResize = (...evt) => {
    const {
      onBackgroundResize
    } = this.state;
    if (onBackgroundResize) {
      onBackgroundResize(...evt);
    }
    this.onResize({
      component: 'background',
      event: evt
    });
  };
  onResize = evt => {
    const {
      onResize
    } = this.state;
    if (onResize) {
      onResize(evt);
    }
  };
  onChange = ({
    type,
    ...rest
  }) => {
    const {
      onChange
    } = this.state;
    this.setState({
      ...rest
    });
    if (onChange) {
      onChange({
        type,
        ...rest
      });
    }
  };
  swipeUp = () => {
    const {
      swipeLocation,
      topLocation,
      middleLocation,
      bottomLocation,
      mode
    } = this.state;
    const loc = swipeLocation;
    switch (loc) {
      case 'bottom':
        this.onChange({
          type: 'swipeUp',
          swipeLocation: 'middle',
          backgroundHeight: `calc( ${mode === 'swipe' ? `100% - ${bottomLocation}` : `100% - ${middleLocation}`} )`,
          overlayHeight: middleLocation
        });
        break;
      case 'middle':
      case 'top':
      default:
        this.onChange({
          type: 'swipeUp',
          swipeLocation: 'top',
          backgroundHeight: mode === 'swipe' ? `calc( 100% - ${bottomLocation} )` : '0%',
          overlayHeight: topLocation
        });
        break;
    }
  };
  snap = () => {
    const {
      swipeLocation,
      middleLocation,
      bottomLocation,
      topLocation,
      mode
    } = this.state;
    switch (swipeLocation) {
      case 'top':
        return this.onChange({
          type: 'snap',
          backgroundHeight: mode === 'swipe' ? `calc( 100% - ${bottomLocation} )` : '0%',
          overlayHeight: topLocation
        });
      case 'bottom':
        return this.onChange({
          type: 'snap',
          backgroundHeight: `calc( 100% - ${bottomLocation} )`,
          overlayHeight: bottomLocation
        });
      case 'middle':
      default:
        return this.onChange({
          type: 'snap',
          backgroundHeight: mode === 'swipe' ? `calc( 100% - ${bottomLocation} )` : `100% - ${middleLocation}`,
          overlayHeight: middleLocation
        });
    }
  };
  swipeDown = () => {
    const {
      swipeLocation,
      middleLocation,
      bottomLocation,
      mode
    } = this.state;
    switch (swipeLocation) {
      case 'top':
        this.onChange({
          type: 'swipeDown',
          swipeLocation: 'middle',
          backgroundHeight: `calc( ${mode === 'swipe' ? `100% - ${bottomLocation}` : `100% - ${middleLocation}`} )`,
          overlayHeight: middleLocation
        });
        break;
      case 'bottom':
        break;
      case 'middle':
      default:
        this.onChange({
          type: 'swipeDown',
          swipeLocation: 'bottom',
          backgroundHeight: `calc( 100% - ${bottomLocation} )`,
          overlayHeight: bottomLocation
        });
    }
  };
  toggleSwipe = () => {
    const {
      swipeLocation
    } = this.state;
    if (swipeLocation !== 'top') {
      this.swipeUp();
    } else {
      this.swipeDown();
    }
  };
  ignore(evt) {
    evt.stopPropagation();
    evt.preventDefault();
  }
  swipeStart = evt => {
    if (evt.target !== this.dividerRef.current && evt.target !== this.dividerMarkRef.current) return;
    this.onChange({
      type: 'swipeStart',
      swiping: true
    });
  };
  swipeMove = ({
    x,
    y
  }) => {
    const {
      swipeLocation,
      topLocation,
      middleLocation,
      bottomLocation,
      mode,
      swiping
    } = this.state;
    if (!swiping || swipeLocation === 'bottom' || this.scrollTop > 0 || this.x === x && (this.y === y || swipeLocation === 'top' && Math.max(0, y) === Math.max(0, this.y))) {
      return null;
    }
    this.x = x;
    this.y = y;
    switch (swipeLocation) {
      case 'top':
        return this.onChange({
          type: 'swipeMove',
          backgroundHeight: `calc( ${mode === 'swipe' ? `100% - ${bottomLocation}` : `0% + ${y}px`} )`,
          overlayHeight: `calc( ${topLocation} - ${y}px )`
        });
      case 'middle':
      default:
        return this.onChange({
          type: 'swipeMove',
          backgroundHeight: `calc( ${mode === 'swipe' ? `100% - ${bottomLocation}` : `100% - ${middleLocation} + ${y}px`} )`,
          overlayHeight: `calc( ${middleLocation} - ${y}px )`
        });
    }
  };
  swipeEnd = (...evt) => {
    const {
      swipeSensitivity,
      swiping
    } = this.state;
    if (!swiping) {
      return;
    }
    const {
      x,
      y
    } = this;
    this.x = null;
    this.y = null;
    this.onChange({
      type: 'swipeEnd',
      swiping: false
    });
    if (Math.abs(y) > Math.abs(x) && y < -1 * swipeSensitivity) {
      this.swipeUp();
    } else if (Math.abs(y) > Math.abs(x) && y > swipeSensitivity) {
      this.swipeDown();
    } else {
      this.snap();
    }
  };
  render() {
    const {
      background,
      overlay
    } = this.props;
    const {
      mode,
      swipeLocation,
      swiping,
      topLocation,
      middleLocation,
      bottomLocation
    } = this.state;
    let {
      backgroundHeight,
      overlayHeight
    } = this.state;
    if (backgroundHeight == null) {
      if (mode === 'swipe') {
        backgroundHeight = `calc( 100% - ${bottomLocation} )`;
      } else {
        switch (swipeLocation) {
          case 'top':
            backgroundHeight = '0%';
            break;
          case 'bottom':
            backgroundHeight = `calc( 100% - ${bottomLocation} )`;
            break;
          case 'middle':
          default:
            backgroundHeight = `100% - ${middleLocation}`;
            break;
        }
      }
    }
    if (overlayHeight == null) {
      switch (swipeLocation) {
        case 'top':
          overlayHeight = topLocation;
          break;
        case 'bottom':
          overlayHeight = bottomLocation;
          break;
        case 'middle':
        default:
          overlayHeight = middleLocation;
          break;
      }
    }
    return /*#__PURE__*/_jsxs("div", {
      className: swiping ? S.swiping : S.swipe,
      children: [/*#__PURE__*/_jsxs("div", {
        ref: this.backgroundRef,
        className: mode === 'swipe' ? S.background : S.top,
        style: {
          height: backgroundHeight
        },
        children: [/*#__PURE__*/_jsx(ReactResizeDetector, {
          handleHeight: true,
          onResize: this.onBackgroundResize
        }), background]
      }), /*#__PURE__*/_jsx(SwipeHandler, {
        style: {
          height: overlayHeight
        },
        className: mode === 'swipe' ? S.overlay : S.bottom,
        onSwipeStart: this.swipeStart,
        onSwipeMove: this.swipeMove,
        onSwipeEnd: this.swipeEnd,
        onScroll: evt => {
          // this.scrollTop = evt.nativeEvent.target.scrollTop
        },
        allowMouseEvents: true,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
          },
          ref: this.overlayRef,
          children: [/*#__PURE__*/_jsx("div", {
            className: classnames(S.showList, swipeLocation !== 'bottom' ? S.zeroHeight : null),
            onMouseDown: this.ignore,
            children: /*#__PURE__*/_jsx(Button, {
              icon: "lv lv-menu",
              variant: "link",
              onClick: this.swipeUp,
              children: t('showData', 'Show Data')
            })
          }), /*#__PURE__*/_jsxs(Content, {
            relative: true,
            className: classnames(S.overlay, swipeLocation === 'bottom' ? S.zeroHeight : null),
            children: [/*#__PURE__*/_jsx(Content.Header, {
              domRef: this.dividerRef,
              className: classnames(S.divider, swipeLocation === 'top' ? S.dividerTop : null),
              children: /*#__PURE__*/_jsx("div", {
                className: S.dividerMark,
                onClick: this.toggleSwipe,
                ref: this.dividerMarkRef
              })
            }), /*#__PURE__*/_jsx(Content.Area, {
              className: S.overlayContainer,
              children: overlay
            })]
          })]
        })
      })]
    });
  }
}
export default Swipe;